export const LocationTypes = {
    SET_LOCATIONTYPES: "SET_LOCATIONTYPES",
    ADD_LOCATIONTYPES: "ADD_LOCATIONTYPES",
    UPDATE_LOCATIONTYPES: "UPDATE_LOCATIONTYPES",
    DELETE_SELECTED_LOCATIONTYPES: "DELETE_SELECTED_LOCATIONTYPES",
    UPDATE_INSTLOCATION: "UPDATE_INSTLOCATION"
}